import { MarketHomePage } from '../../components/market/MarketHomePage'
import { getAirconPageProps } from '../../lib/market-pages'
import content from '../../data/markets/my/home'

// Bump by hand when the copy changes (feeds dateModified).
const CONTENT_REVIEWED = '2026-10-03'

export const getStaticProps = () => getAirconPageProps('my', null, CONTENT_REVIEWED)

export default function Page(props) {
    return <MarketHomePage {...props} content={content} />
}
